<template>
  <div v-if="collectionRequest.collection_request_id">
    <v-card-title>
      <span style="color: #0074BA">連絡事項</span>&emsp;
    </v-card-title>
    <v-card-text>
      <!-- 排出業者から収集運搬業者への連絡事項 -->
      <v-row>
        <v-col cols="12">
          <v-textarea
            :value='collectionRequest.emissions_message'
            filled
            hide-details="auto"
            label='連絡事項（排出から収運）'
            no-resize
            outlined
            persistent-placeholder
            readonly
            required
            rows='4'
          />
        </v-col>
      </v-row>
      <!-- /排出業者から収集運搬業者への連絡事項 -->

      <!-- 収運業者から排出事業者への連絡事項 -->
      <v-row>
        <v-col cols="12">
          <v-textarea
            :value='collectionRequest.transports_message'
            filled
            hide-details="auto"
            label='連絡事項（収運から排出）'
            no-resize
            outlined
            persistent-placeholder
            readonly
            required
            rows='4'
          />
        </v-col>
      </v-row>
      <!-- /収運業者から排出事業者への連絡事項 -->
    </v-card-text>
  </div>
</template>
<script>

export default {
  name: 'BlockMemo',
  components: {},
  mixins: [],
  /**
   * @typedef collection_request { Object }
   * @property emissions_message { string }
   * @property transports_message { string }
   */
  props: {
    collectionRequest: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  methods: {}

}
</script>

<style scoped>

</style>
